import { randomName, randomWord } from '@rtls/map/util/factory/factory.util';
import * as Factory from 'factory.ts';
import { Participant } from './participant.model';

export const participantFactory = Factory.makeFactory<Participant>({
	extId: Factory.each(() => randomWord()),
	provider: Factory.each(() => randomName()),
	uuid: Factory.each(() => randomWord()),
});
